// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import ElementUI from 'element-ui'
import VueResource from 'vue-resource'
import VueRouter from 'vue-router'
import authService from './utils/authService'
import Vuex from 'vuex'
import locale from 'element-ui/lib/locale/lang/en'
import { sync } from 'vuex-router-sync'
import store from './store'

// import SchedualGroup from './views/order-system/schedual-group/RenderGroup.vue'
Vue.use(ElementUI, { locale })
Vue.config.productionTip = false
Vue.use(Vuex)
Vue.use(VueResource)
Vue.use(VueRouter)
Vue.http.options.crossOrigin = true
/* eslint-disable no-new */

function requireAuth (to, from, next) {
  console.log('!authService.isLogin()', authService.isLogin())
  console.log('process.env.Auth', process.env.Auth)
  if (process.env.BACKEND_ENV === 'Electron') {
    next()
  } else if (!authService.isLogin()) {
    next({
      path: '/login',
      query: { redirect: to.fullPath }
    })
  } else {
    next()
  }
}
const router = new VueRouter({
  mode: 'history',
  base: '/', // __dirname
  routes: [
    {
      path: '/',
      component: function (resolve) {
        require.ensure(['./views/Home.vue'], function () {
          resolve(require('./views/Home.vue'))
        })
      },
      beforeEnter: requireAuth,
      redirect: '/home'
    },
    {
      path: '/login',
      component: function (resolve) {
        require.ensure(['./views/Login.vue'], function () {
          resolve(require('./views/Login.vue'))
        })
      }
    },
    {
      path: '/unAuth',
      component: function (resolve) {
        require.ensure(['./views/home-router/UnAuth.vue'], function () {
          resolve(require('./views/home-router/UnAuth.vue'))
        })
      }
    },
    {
      path: '/apply',
      component: function (resolve) {
        require.ensure(['./views/home-router/Apply.vue'], function () {
          resolve(require('./views/home-router/Apply.vue'))
        })
      }
    },
    { path: '/logout',
      beforeEnter (to, from, next) {
        authService.signOut()
        next('/login')
      }
    },
    {
      path: '/home',
      beforeEnter: requireAuth,
      component: function (resolve) {
        require.ensure(['./views/Home.vue'], function () {
          resolve(require('./views/Home.vue'))
        })
      }
    }
    // {
    //   path: '/admin',
    //   beforeEnter: requireAuth,
    //   component: function (resolve) {
    //     require.ensure(['./views/admin-view/index.vue'], function () {
    //       resolve(require('./views/admin-view/index.vue'))
    //     })
    //   }
    // }
    // { path: '/hello', component: Hello }
    // { path: '/test', component: resolve => require(['./views/test/Test.vue'], resolve) }
  ]
})
sync(store, router)

new Vue({
  store,
  router,
  template: '<App/>',
  components: { App }
}).$mount('#app')
window.router = router



// WEBPACK FOOTER //
// ./src/main.js